export const fmt = (v, d = 0) =>
  new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: d === 2 ? 3 : d,
    maximumFractionDigits: d === 2 ? 3 : d,
  }).format(Number.isFinite(Number(v)) ? Number(v) : 0);

export const STATUT_STYLE = {
  'Sur site': 'border-violet-300 bg-violet-50 text-violet-700',
  'En attente': 'border-slate-300 bg-slate-50 text-slate-600',
  'En trituration': 'border-amber-200 bg-amber-50 text-amber-700',
  'En transit': 'border-amber-200 bg-amber-50 text-amber-700',
  Trituré: 'border-sky-200 bg-sky-50 text-sky-700',
  Livré: 'border-sky-200 bg-sky-50 text-sky-700',
  Décompté: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  Payé: 'border-emerald-200 bg-emerald-50 text-emerald-700',
};

export const StatutBadge = ({ statut }) => (
  <span
    data-testid={`statut-badge-${statut}`}
    className={`inline-block border px-1.5 py-0.5 font-data text-[11px] uppercase tracking-[0.06em] ${
      STATUT_STYLE[statut] ?? STATUT_STYLE['En attente']
    }`}
  >
    {statut}
  </span>
);

export const QualiteBadge = ({ famille, label }) => (
  <span
    data-testid={`qualite-badge-${famille}`}
    className={`inline-flex items-center gap-1.5 border px-1.5 py-0.5 font-data text-[11px] uppercase tracking-[0.06em] ${
      famille === 'lampante'
        ? 'border-orange-300 bg-orange-50 text-orange-800'
        : 'border-emerald-200 bg-emerald-50 text-emerald-700'
    }`}
  >
    <span className={`h-1.5 w-1.5 ${famille === 'lampante' ? 'bg-orange-500' : 'bg-emerald-600'}`} />
    {label}
  </span>
);

export const ParcoursBadge = ({ parcours }) => (
  <span
    data-testid={`parcours-badge-${parcours}`}
    className={`inline-block border px-1.5 py-0.5 font-data text-[11px] uppercase tracking-[0.06em] ${
      parcours === 'client'
        ? 'border-sky-200 bg-sky-50 text-sky-700'
        : 'border-slate-300 bg-slate-100 text-slate-700'
    }`}
  >
    {parcours === 'client' ? 'Client' : 'Fournisseur'}
  </span>
);

export const PageTitle = ({ emoji, titre, sous, action }) => (
  <div className="flex flex-wrap items-end justify-between gap-4">
    <div>
      <h1 className="font-heading text-2xl font-black tracking-tight text-slate-900 sm:text-3xl">
        {emoji} {titre}
      </h1>
      <p className="mt-1 text-sm text-slate-600">{sous}</p>
    </div>
    {action}
  </div>
);

export const StatBlock = ({ titre, accent, items, testid }) => (
  <div data-testid={testid} className={`border border-slate-200 border-l-2 bg-white ${accent}`}>
    <p className="border-b border-slate-200 px-4 py-2 text-xs font-bold uppercase tracking-[0.1em] text-slate-500">
      {titre}
    </p>
    <div className="grid gap-px bg-slate-200" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0,1fr))` }}>
      {items.map(([k, v]) => (
        <div key={k} className="bg-white px-3 py-2.5">
          <p className="text-[11px] text-slate-500">{k}</p>
          <p className="tabular font-data text-base font-semibold text-slate-900">{v}</p>
        </div>
      ))}
    </div>
  </div>
);
